import { useQuery } from "react-query";
import { GetLayananResponse } from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params?: { isNaikKelas?: boolean }) => {
    const apiUrl = queryString.stringifyUrl({
        url: "/api/layanan",
        query: {
            naikKelas: params?.isNaikKelas ? 1 : 0,
        },
    });
    const { data } = await axios.get<GetLayananResponse>(apiUrl);
    return data.data;
};

export default function useLayanan(params?: { isNaikKelas?: boolean }) {
    return useQuery<GetLayananResponse["data"]>(["layanan", "list", params], () =>
        handleRequest(params),
    );
}
